/**
 *
 * @type {{init: layout.init, run: layout.run, activateDevMode: layout.activateDevMode, checkViewportelements: layout.checkViewportelements}}
 *
 * set data attribute [data-viewport-watcher] on element to watch if it is in viewport
 * element gets data-attribute [data-in-viewport] set to true or false
 * use css to style the element when it is in viewport
 *
 */
let layout = {

    init: () => {

        layout.run();

    },

    run: () => {

        layout.activateDevMode();

        let toWatch = document.querySelectorAll('[data-viewport-watcher]');
        if (toWatch.length > 0) {
            layout.checkViewportelements(toWatch);
            document.body.classList.add('js_ready');
        }
    },

    checkViewportelements: (elements) => {
        const callback = (entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.dataset.inViewport = "true";
                } else {
                    entry.target.dataset.inViewport = "false";
                }
            })
        };

        const options = {
            // the root object (window, viewport or any element)
            root: null,
            // margin around the root
            rootMargin: '30px',
            // even one pixel is visible
            threshold: 1
        };
        const Observer = new IntersectionObserver(callback, options);
        elements.forEach((observerEL) => {
            Observer.observe(observerEL);
        });

    },


    activateDevMode: () => {
        // add devmode button
        const body = document.querySelector('body');
        const toolbar = document.querySelectorAll('.sf-toolbar');
        let devmode = window.localStorage.getItem("dev");


        let toggleGridOverlay = () => {
            if (window.localStorage.getItem("dev") === "true") {
                window.localStorage.removeItem("dev");
                hideGridOverlay()
            } else {
                window.localStorage.setItem("dev", "true");
                showGridOverlay();
            }
        }

        let showGridOverlay = () => {
            body.classList.add('show-grid-helper');
        }

        let hideGridOverlay = () => {
            body.classList.remove('show-grid-helper');
        }


        if (toolbar.length > 0) {
            body.classList.add('is-devmode');

            var button = document.createElement('button');
            button.setAttribute('title', 'ctrl + g to toggle grid overlay');
            button.setAttribute('class', 'btn-devmode');
            document.body.append(button);

            button.addEventListener('click', () => {
                toggleGridOverlay();
            });

            //add shortcut for displaying grid overlay
            document.onkeyup = function (e) {
                if (e.ctrlKey && e.which === 71) {
                    toggleGridOverlay();
                }
            };

            if (window.localStorage.getItem("dev") === "true") {
                showGridOverlay();
            }
        } else {
            hideGridOverlay();
        }

    }
};

export default layout.init();